// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBNl7Xj-putxWoF_Z3eXE_UQRvgiy82VrY",
  authDomain: "louievoicewebsite.firebaseapp.com",
  databaseURL: "https://louievoicewebsite.firebaseio.com",
  projectId: "louievoicewebsite",
  storageBucket: "louievoicewebsite.appspot.com",
  messagingSenderId: "578543330517",
  appId: "1:578543330517:web:0fbed8568357571db1ae5c",
  measurementId: "G-HE8CKDH76Q"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
